import {
  bgLocale,
  daLocale,
  deLocale,
  enGbLocale,
  esLocale,
  frLocale,
  hiLocale,
  huLocale,
  itLocale,
  nlLocale,
  plLocale,
  ptBrLocale,
  roLocale,
  ruLocale,
  slLocale,
  trLocale,
  ukLocale,
} from 'ngx-bootstrap/locale';
import 'moment/locale/it';
import 'moment/locale/es';
import 'moment/locale/en-gb';
import 'moment/locale/de';
import 'moment/locale/fr';
import 'moment/locale/pt-br';
import 'moment/locale/el';
import 'moment/locale/ru';
import 'moment/locale/pl';
import 'moment/locale/hu';
import 'moment/locale/sl';
import 'moment/locale/ro';
import 'moment/locale/uk';
import 'moment/locale/tr';
import 'moment/locale/nl';
import 'moment/locale/da';
import 'moment/locale/bg';
import 'moment/locale/hi';
import { LocaleData } from 'ngx-bootstrap/chronos';

const elLocale: LocaleData = {
  abbr: 'el',
  months:
    'Ιανουάριος_Φεβρουάριος_Μάρτιος_Απρίλιος_Μάιος_Ιούνιος_Ιούλιος_Αύγουστος_Σεπτέμβριος_Οκτώβριος_Νοέμβριος_Δεκέμβριος'.split(
      '_'
    ),
  monthsShort: 'Ιαν_Φεβ_Μαρ_Απρ_Μαι_Ιουν_Ιουλ_Αυγ_Σεπ_Οκτ_Νοε_Δεκ'.split('_'),
  weekdays: 'Κυριακή_Δευτέρα_Τρίτη_Τετάρτη_Πέμπτη_Παρασκευή_Σάββατο'.split('_'),
  weekdaysShort: 'Κυρ_Δευ_Τρι_Τετ_Πεμ_Παρ_Σαβ'.split('_'),
  weekdaysMin: 'Κυ_Δε_Τρ_Τε_Πε_Πα_Σα'.split('_'),
  longDateFormat: {
    LT: 'h:mm A',
    LTS: 'h:mm:ss A',
    L: 'DD/MM/YYYY',
    LL: 'D MMMM YYYY',
    LLL: 'D MMMM YYYY LT',
    LLLL: 'dddd, D MMMM YYYY LT',
  },
  calendar: {
    sameDay: '[Σήμερα στις] LT',
    nextDay: '[Αύριο στις] LT',
    nextWeek: 'dddd [στις] LT',
    lastDay: '[Χθες στις] LT',
    lastWeek: '[περασμένη] dddd [στις] LT',
    sameElse: 'L',
  },
  relativeTime: {
    future: 'σε %s',
    past: '%s πριν',
    s: 'μερικά δευτερόλεπτα',
    m: 'ένα λεπτό',
    mm: '%d λεπτά',
    h: 'μια ώρα',
    hh: '%d ώρες',
    d: 'μια μέρα',
    dd: '%d μέρες',
    M: 'ένα μήνα',
    MM: '%d μήνες',
    y: 'ένα χρόνο',
    yy: '%d χρόνια',
  },
  ordinal(number: number) {
    return number + (number === 1 ? 'η' : 'ης');
  },
  week: {
    dow: 1, // Monday is the first day of the week.
    doy: 4, // The week that contains Jan 4th is the first week of the year.
  },
};

// Esporta la configurazione delle lingue
export const SUPPORTED_LANGUAGES = [
  'it',
  'es',
  'en',
  'de',
  'fr',
  'pt',
  'pt_BR',
  'el',
  'ru',
  'pl',
  'hu',
  'sl',
  'ro',
  'uk',
  'tr',
  'nl',
  'da',
  'bg',
  'hi',
];

export const LOCALES = [
  { code: 'it', locale: itLocale },
  { code: 'es', locale: esLocale },
  { code: 'en', locale: enGbLocale },
  { code: 'de', locale: deLocale },
  { code: 'fr', locale: frLocale },
  { code: 'pt', locale: ptBrLocale },
  { code: 'pt-br', locale: ptBrLocale }, // ptBrLocale per br locale
  { code: 'el', locale: elLocale }, // locale personalizzata per il greco
  { code: 'ru', locale: ruLocale },
  { code: 'pl', locale: plLocale },
  { code: 'hu', locale: huLocale },
  { code: 'sl', locale: slLocale },
  { code: 'ro', locale: roLocale },
  { code: 'uk', locale: ukLocale },
  { code: 'tr', locale: trLocale },
  { code: 'nl', locale: nlLocale },
  { code: 'da', locale: daLocale },
  { code: 'bg', locale: bgLocale },
  { code: 'hi', locale: hiLocale },
];

export const momentLocaleMap: { [key: string]: string } = {
  it: 'it',
  es: 'es',
  en: 'en-gb',
  de: 'de',
  fr: 'fr',
  pt: 'pt-br',
  pt_BR: 'pt-br',
  el: 'el',
  ru: 'ru',
  pl: 'pl',
  hu: 'hu',
  sl: 'sl',
  ro: 'ro',
  uk: 'uk',
  tr: 'tr',
  nl: 'nl',
  da: 'da',
  bg: 'bg',
  hi: 'hi',
};
